import React, { useState, useEffect, useRef } from 'react';
import { Web } from 'sip.js';
import './styles.css';  // CSS original
import AudioService from './AudioService';
import NotificationService from './NotificationService';
import { Crud_Catalogos } from "../../../../herramientas/Crud_Catalogos";

import { Switch } from 'react-router-dom';
const softphone = sessionStorage.getItem("softphone") !== null? JSON.parse(sessionStorage.getItem("softphone")): {};
let usuario= JSON.parse(sessionStorage.getItem("usuario")|| '{}');
let softphonePlataforma= {};
function TelefonoSipV3() {
  // Configuración SIP
  const configuracion = {
    grupo: softphone.grupo,  // Reemplaza con tu valor real
    idPbx: softphone.idPbx   // Reemplaza con tu valor real
  };
  
  // Estados para el teléfono SIP
  const [userAgent, setUserAgent] = useState(null);
  const [session, setSession] = useState(null);
  const [status, setStatus] = useState('disconnected');
  const [destination, setDestination] = useState('');
  const [lastNumber, setLastNumber] = useState('');
  const [error, setError] = useState('');
  const [isMuted, setIsMuted] = useState(false);
  const [isSpeaker, setIsSpeaker] = useState(false);
  const [activeTab, setActiveTab] = useState('keypad');
  
  // Estado para el botón de pausa
  const [isPaused, setIsPaused] = useState(false);
  const [isProcessingPause, setIsProcessingPause] = useState(false);
  
  // 0 inicialización sin validar, 1 validando, 2 sesion previa activa, 3 sesion previa inactiva
  const [sesionPreviaActiva, setSesionPreviaActiva]= useState(0);
  // Estado para el historial de llamadas
  const [callHistory, setCallHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(true);
  const [numeroEntrante, setNumeroEntrante]= useState("");
  const [url, setUrl]= useState("");
  const [puerto, setPuerto]= useState("");
  // Referencias para elementos de audio
  const remoteAudioRef = useRef(null);
  const localAudioRef = useRef(null);
  const callTypeRef = useRef(null);
  const outgoingNumberRef = useRef(''); // Para guardar el número de llamada saliente
  const rejectRef = useRef(false); // Para guardar el número de llamada saliente
  const callStartTimeRef = useRef(null); // Para medir duración de llamadas
  const callerIdRef = useRef('');
  // Función para manejar pausa/reanudar llamadas entrantes
  const handleTogglePause = async () => {
    if (isProcessingPause) return; // Evitar múltiples clicks
    
    setIsProcessingPause(true);
    setError('');
    try {
      const estatus = isPaused ? false : true;
      const motivo = isPaused ? 'Disponible' : 'Offline';
      const action = isPaused ? 'Reanudando' : 'Pausando';
      
      console.log(`${action} llamadas entrantes...`);
      console.log(softphonePlataforma);
      switch (softphonePlataforma.softphoneConfiguracionId) {
        case 1:
          await Crud_Catalogos( "softphone/pausa?estatus="+estatus+"&motivo="+motivo, "pausa", "post", "", {}, "", "softphone")
          .then((data) => {
            setIsPaused(!isPaused);
            const message = isPaused ? 'Llamadas reanudadas' : 'Llamadas pausadas';
            console.log(`${message} exitosamente`);
          }).catch((err) => {
            console.error('Error al cambiar estado de pausa:', err);
            setError(`Error al ${isPaused ? 'reanudar' : 'pausar'} llamadas: ${err.message || 'Error desconocido'}`);
          });
          break;
        case 2:
        case 3:
          await Crud_Catalogos( "softphone_v3/pausa?provedor="+softphonePlataforma.softphoneConfiguracionId+"&estatus="+estatus+"&motivo="+"1"+"&queue="+softphonePlataforma.extension, "pausa", "post", "", {}, "", "softphone")
          .then((data) => {
            setIsPaused(!isPaused);
            const message = isPaused ? 'Llamadas reanudadas' : 'Llamadas pausadas';
            console.log(`${message} exitosamente`);
          }).catch((err) => {
            console.error('Error al cambiar estado de pausa:', err);
            setError(`Error al ${isPaused ? 'reanudar' : 'pausar'} llamadas: ${err.message || 'Error desconocido'}`);
          });
          break;
        case 4:
          await Crud_Catalogos( "softphone_v3/pausa?provedor=4&estatus="+estatus+"&motivo="+motivo+"&queue="+softphonePlataforma.extension, "pausa", "post", "", {}, "", "softphone")
          .then((data) => {
            setIsPaused(!isPaused);
            const message = isPaused ? 'Llamadas reanudadas' : 'Llamadas pausadas';
            console.log(`${message} exitosamente`);
          }).catch((err) => {
            console.error('Error al cambiar estado de pausa:', err);
            setError(`Error al ${isPaused ? 'reanudar' : 'pausar'} llamadas: ${err.message || 'Error desconocido'}`);
          });
          break;
      
        default:
          break;
      }
      
    } catch (error) {
      console.error('Error en handleTogglePause:', error);
      setError(`Error al ${isPaused ? 'reanudar' : 'pausar'} llamadas: ${error.message || 'Error desconocido'}`);
    } finally {
      setIsProcessingPause(false);
    }
  };

  //validar si el webphone ya esta iniciado en otro equipo
  useEffect(async()=>{
    //verificar servidor
     //getfuntion("get", "", "", "softphone_configuracion/grupo/"+configuracion.grupo,"softphone_configuracion");
     if( softphone.id){
      softphonePlataforma= {};
      await Crud_Catalogos(
                "softphone_configuracion/"+softphone.idPlataforma,
                'softphone_configuracion',
                'get',
                '',
                {},
                '',
                'softphone'
              )
                .then((obj) => {
                  softphonePlataforma= obj;
                })
                .catch((err) => console.log(err));
      //Buscar configuracion de proveedor
      await Crud_Catalogos(
                "softphone_server_configuracion/"+softphonePlataforma.softphoneConfiguracionId,
                'softphone_server_configuracion',
                'get',
                '',
                {},
                '',
                'softphone'
              )
                .then((obj) => {
                  setUrl(obj.dominioWss);
                  setPuerto(obj.puertoWss);
                })
                .catch((err) => console.log(err));
      switch (softphonePlataforma.softphoneConfiguracionId) {
        case 1:
          let sessionPrevia= false;
          await Crud_Catalogos(
                  'softphone/ps_contact?endpoint=' + softphone.username,
                  'ps_contact',
                  'get',
                  '',
                  {},
                  '',
                  'softphone'
                )
                  .then((obj) => {
                    console.log(obj);
                    if( obj && obj.endpoint ){
                      /*
                        {
                          "endpoint": "pamiro",
                          "userAgent": "React Native JsSIP 3.7.6"
                        }
                      */
                      setSesionPreviaActiva(2);
                      sessionPrevia= true;
                    }else{
                      setSesionPreviaActiva(3);// sesion previa inactiva (si cargar telefono)
                    }
                  })
                  .catch((err) => console.log(err));
          if( !sessionPrevia ){
            let queuemember= [];
            await Crud_Catalogos(
                    'softphone/queuemember?username=' + softphone.username,
                    'queuemember',
                    'get',
                    '',
                    {},
                    '',
                    'softphone'
                  )
                    .then((obj) => {
                      console.log(obj);
                      queuemember= obj;
                      
                    })
                    .catch((err) => console.log(err));
            if( queuemember && queuemember[0] && queuemember[0].uniqueid ){//Si esta logueado. Desloguear y volver a loguear (para eviar errores)
                        /*
                          [
                            {
                              "uniqueid": "3",
                              "membername": "pamiro",
                              "memberInterface": "PJSIP/pamiro",
                              "queueName": "6001",
                              "stateInterface": "PJSIP/pamiro",
                              "paused": "0",
                              "reasonPaused": "Conectado"
                            }
                          ]
                        */
              await Crud_Catalogos( "softphone/desloguear_en_grupo", "softphone", "post", "", {}, "", "softphone")
                    .then((data) => {
                      console.log(data);
                    }).catch((err) => console.log(err));
              await Crud_Catalogos('softphone/loguear_en_grupo', 'softphone', 'post', '',{}, '','softphone')
                    .then((data) => {
                              console.log(data);
                    }).catch((err) => console.log(err));
            }else{// solo loguear
              await Crud_Catalogos('softphone/loguear_en_grupo', 'softphone', 'post', '',{}, '','softphone')
                    .then((data) => {
                      console.log(data);
                    }).catch((err) => console.log(err));
            }
          }
          break;
        case 2://Loguear
        case 3:
          await Crud_Catalogos(
                "softphone_v3/desloguear_agente?provedor="+softphonePlataforma.softphoneConfiguracionId,
                'desloguear_agente',
                'post',
                '',
                {},
                '',
                'softphone'
              )
                .then((obj) => {
                })
                .catch((err) => console.log(err));
          await Crud_Catalogos(
                "softphone_v3/loguear_agente?provedor="+softphonePlataforma.softphoneConfiguracionId,
                'loguear_agente',
                'post',
                '',
                {},
                '',
                'softphone'
              )
                .then((obj) => {
                  setSesionPreviaActiva(3);
                })
                .catch((err) => console.log(err));
          break;
        case 4://Loguear Lambicom
          await Crud_Catalogos(
                "softphone_v3/desloguear_agente?provedor=4",
                'desloguear_agente',
                'post',
                '',
                {},
                '',
                'softphone'
              )
                .then((obj) => {
                })
                .catch((err) => console.log(err));
          await Crud_Catalogos(
                "softphone_v3/loguear_agente?provedor=4",
                'loguear_agente',
                'post',
                '',
                {},
                '',
                'softphone'
              )
                .then((obj) => {
                  setSesionPreviaActiva(3);
                })
                .catch((err) => console.log(err));
          break;
      
        default:
          break;
      }
    }
  },[]);
  
  // Inicializar el servicio de audio cuando el usuario interactúa
  useEffect(() => {
    const initAudio = () => {
      // Reanudar el contexto de audio (necesario en Chrome y Safari)
      AudioService.resumeAudioContext();
      // Quitar el listener después de inicializar
      window.removeEventListener('click', initAudio);
    };
    
    // Agregar un listener para la primera interacción
    window.addEventListener('click', initAudio);
    
    return () => {
      window.removeEventListener('click', initAudio);
    };
  }, []);
  
  // Estado para el tiempo actual (simulando la barra de estado del iPhone)
  const [currentTime, setCurrentTime] = useState('');

  // Referencia al contenedor principal para manejar el foco
  const phoneContainerRef = useRef(null);

    // Estado para notificaciones
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  
  // Inicializar el servicio de notificaciones
  useEffect(() => {
    const initNotifications = async () => {
      try {
        const granted = await NotificationService.initialize();
        setNotificationsEnabled(granted);
        console.log('Notificaciones ' + (granted ? 'habilitadas' : 'deshabilitadas'));
      } catch (error) {
        console.error('Error al inicializar notificaciones:', error);
      }
    };
    
    initNotifications();
  }, []);  
  /*
  {
    "event": "clic_call",
    "numero": "7621004239"
  }
*/
  const procesarMensaje = (msg) => {
    //console.log("procesarMensaje", msg);
    if ( msg && msg.event) {
      switch (msg.event) {
        case "clic_call":
          let numero= Number(msg.numero.replaceAll(" ", ""));
          if(
            Number.isFinite(numero) && Number.isInteger(numero) && String(numero).length > 3
          ){
            setDestination(String(numero));
            handleCall(String(numero));
          }
          break;
        default:
          break;
      }
    }
  };

  // Obtener letra inicial del número para el avatar
  const getInitial = (number) => {
    if (!number) return '?';
    return number.charAt(0).toUpperCase();
  };

  // Manejador de eventos de teclado
  const handleKeyDown = (event) => {
    // Prevenir comportamiento predeterminado para teclas específicas
    if ([' ', 'Enter', 'Backspace', 'Delete', 'Escape'].includes(event.key)) {
      event.preventDefault();
    }

    // Dígitos 0-9, * y #
    if (/^[0-9*#]$/.test(event.key)) {
      handleDigitPress(event.key);
    } 
    // Teclas de función para llamada
    else if (event.key === 'Enter') {
      if (status === 'registered' && destination) {
        handleCall();
      } else if (status === 'ringing') {
        handleAnswer();
      }
    } 
    // Espacio para alternar entre llamar y colgar
    else if (event.key === ' ') {
      if (status === 'registered' && destination) {
        handleCall();
      } else if (status === 'connected' || status === 'calling') {
        handleHangup();
      } else if (status === 'ringing') {
        handleAnswer();
      }
    } 
    // Escape o Backspace para colgar
    else if ((event.key === 'Escape' || event.key === 'Backspace') && 
             (status === 'connected' || status === 'calling' || status === 'ringing')) {
      handleHangup();
    } 
    // Backspace para borrar último dígito (solo si no hay llamada activa)
    else if (event.key === 'Backspace' && status !== 'connected' && status !== 'calling' && status !== 'ringing') {
      handleBackspace();
    } 
    // Delete para limpiar todo el número
    else if (event.key === 'Delete' && status !== 'connected' && status !== 'calling' && status !== 'ringing') {
      handleClear();
    } 
    // Tecla 'M' para silenciar/activar micrófono
    else if (event.key.toLowerCase() === 'm' && status === 'connected') {
      handleToggleMute();
    } 
    // Tecla 'S' para altavoz
    else if (event.key.toLowerCase() === 's' && status === 'connected') {
      handleToggleSpeaker();
    }
    // Tecla 'R' para remarcar
    else if (event.key.toLowerCase() === 'r' && status === 'registered' && lastNumber) {
      handleRedial();
    }
    // Tecla 'P' para pausar/reanudar llamadas entrantes
    else if (event.key.toLowerCase() === 'p' && status === 'registered') {
      handleTogglePause();
    }
  };

  const handleDocumentPaste = (event) => {
    // Evita que el navegador realice el pegado predeterminado
    // Esto es crucial si quieres procesar el texto y quizás insertarlo en otro lugar.
    // Si no lo pones, el texto se pegará donde el cursor esté activo, además de tu lógica.
    event.preventDefault(); 
    // Accede a los datos del portapapeles
    let text = event.clipboardData.getData('text');
    let numero= Number(text.replaceAll(" ", ""));
    if(
      Number.isFinite(numero) && Number.isInteger(numero) && String(numero).length > 3
    ){
      setDestination(String(numero));
    }
    
  };

  // Enfocar el contenedor del teléfono y configurar eventos de teclado
  useEffect(() => {
    // Agregar listener para eventos de teclado
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('paste', handleDocumentPaste);

    // Asegurar que el teléfono tenga foco para recibir eventos de teclado
    if (phoneContainerRef.current) {
      phoneContainerRef.current.focus();
    }
    
    // Limpiar al desmontar
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('paste', handleDocumentPaste);
    };
  }, [status, destination, lastNumber, isPaused]); // Agregamos isPaused a las dependencias

  // Actualizar la hora cada minuto
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      setCurrentTime(`${hours}:${minutes < 10 ? '0' + minutes : minutes}`);
    };
    
    updateTime();
    const interval = setInterval(updateTime, 60000);
    
    return () => clearInterval(interval);
  }, []);

  // Recuperar el historial de llamadas al inicio
  useEffect(() => {
    const loadCallHistory = () => {
      setIsLoadingHistory(true);
      try {
        const savedHistory = localStorage.getItem('sipCallHistory');
        if (savedHistory) {
          const parsedHistory = JSON.parse(savedHistory);
          setCallHistory(parsedHistory);
        }
      } catch (error) {
        console.error('Error al cargar historial de llamadas:', error);
      } finally {
        setIsLoadingHistory(false);
      }
    };
    
    loadCallHistory();
  }, []);
  
  // Función para guardar una nueva entrada en el historial
  const saveCallToHistory = (number, type, duration = 0) => {
    const newCall = {
      id: Date.now(), // ID único basado en timestamp
      number,
      timestamp: new Date().toISOString(),
      type, // 'outgoing', 'incoming', 'missed', 'rejected'
      duration // en segundos
    };
    
    // Actualizar el estado con la nueva llamada al principio
    const updatedHistory = [newCall, ...callHistory].slice(0, 50); // Mantener solo las últimas 50 llamadas
    setCallHistory(updatedHistory);
    
    // Guardar en localStorage
    try {
      localStorage.setItem('sipCallHistory', JSON.stringify(updatedHistory));
    } catch (error) {
      console.error('Error al guardar historial de llamadas:', error);
    }
  };
  
  // Función para borrar el historial de llamadas
  const clearCallHistory = () => {
    setCallHistory([]);
    try {
      localStorage.removeItem('sipCallHistory');
    } catch (error) {
      console.error('Error al borrar historial de llamadas:', error);
    }
  };
  
  // Recuperar el último número marcado al inicio
  useEffect(() => {
    const savedNumber = localStorage.getItem('lastDialedNumber');
    if (savedNumber) {
      setLastNumber(savedNumber);
    }
  }, []);

  // Escuchar mensajes de clic-to-call vía BroadcastChannel
  const handleCallRef = useRef(null);

  useEffect(() => {
    const channel = new BroadcastChannel("webphone-call-channel");
    channel.onmessage = (event) => {
      const msg = event.data;
      if (msg && msg.event === "clic_call") {
        let numero = Number(String(msg.numero).replaceAll(" ", ""));
        if (Number.isFinite(numero) && Number.isInteger(numero) && String(numero).length > 3) {
          const numStr = String(numero);
          setDestination(numStr);
          if (handleCallRef.current) {
            handleCallRef.current(numStr);
          }
        }
      }
    };
    return () => channel.close();
  }, []);

  // Configuración del agente SIP
  useEffect(() => {
    if(sesionPreviaActiva !== 3){ return }
    // Configuración del UA cuando el componente monta
    const ua = new Web.SimpleUser('wss://'+url+':'+puerto+'/ws', {
      aor: `sip:${softphone.username}@${url}`,
      userAgentOptions: {
        authorizationUsername: softphone.username,
        authorizationPassword: softphone.password, // Importante: Reemplaza con la contraseña real
        displayName: 'Agente ' + configuracion.idPbx,
        // Configuración adicional para userAgent
        extraHeaders: [
          `GroupID: ${configuracion.grupo}`,
          `GroupName: ${"Grupo"}`,
          `AgentID: ${configuracion.idPbx}`,
        ]
      },
      media: {
        constraints: { audio: true, video: false },
        remote: { audio: remoteAudioRef.current },
        local: { audio: localAudioRef.current }
      }
    });
    
    setUserAgent(ua);
    
    // Registrar listeners de eventos
    ua.delegate = {
      onCallReceived: () => {
        console.log("Llamada entrante");
        setStatus('ringing');
        callTypeRef.current = 'incoming';
        callStartTimeRef.current = Date.now(); // Guardar tiempo de inicio
        rejectRef.current= false;
        // Con Web.SimpleUser, obtienes el caller ID desde el userAgent
        let callerId = 'Desconocido';
        
        try {
          // En Web.SimpleUser, la sesión activa se obtiene de esta manera
          const currentSession = ua.session;
          
          if (currentSession) {
            console.log("Sesión actual:", currentSession);
            
            // Intentar obtener desde remoteIdentity
            if (currentSession.remoteIdentity && currentSession.remoteIdentity.uri) {
              if (currentSession.remoteIdentity.uri.user) {
                callerId = currentSession.remoteIdentity.uri.user;
              } else if (currentSession.remoteIdentity.displayName) {
                callerId = currentSession.remoteIdentity.displayName;
              }
            }
            
            // Si no funciona, intentar desde el request
            if (callerId === 'Desconocido' && currentSession.request) {
              if (currentSession.request.from && currentSession.request.from.uri && currentSession.request.from.uri.user) {
                callerId = currentSession.request.from.uri.user;
              }
            }
            
            // Último intento: parsear desde headers
            if (callerId === 'Desconocido' && currentSession.request && currentSession.request.headers) {
              const fromHeader = currentSession.request.getHeader('From');
              if (fromHeader) {
                console.log("From Header:", fromHeader);
                // Parsear algo como: "Display Name" <sip:user@domain.com>
                const sipMatch = fromHeader.match(/sip:([^@;]+)/);
                if (sipMatch && sipMatch[1]) {
                  callerId = sipMatch[1];
                }
              }
            }
            
            console.log('Caller ID detectado:', callerId);
            setSession(currentSession);
          }
        } catch (error) {
          console.error('Error al obtener caller ID:', error);
          console.log('UserAgent completo:', ua);
        }
        
        // Guardar caller ID para futuras referencias
        callerIdRef.current = callerId;
        setNumeroEntrante(callerId);
        // Mostrar notificación si está habilitado
        if (notificationsEnabled) {
          NotificationService.showIncomingCallNotification(
            callerId,
            // Callback para aceptar llamada
            () => {
              if (status === 'ringing') {
                handleAnswer();
              }
            },
            // Callback para rechazar llamada
            () => {
              if (status === 'ringing') {
                handleHangup();
              }
            }
          );
        }
        
        // Reproducir tono de timbre
        AudioService.startRingTone();
      },
      onCallAnswered: () => {
        console.log("Llamada contestada");
        console.log("Tipo de llamada:", callTypeRef.current); // Debug
        console.log("Número saliente:", outgoingNumberRef.current); // Debug
        console.log("reject "+ rejectRef.current);//Debug
        setStatus('connected');
        callStartTimeRef.current = Date.now(); // Actualizar tiempo de inicio para llamadas conectadas
        
        // Cerrar notificación si existe
        NotificationService.closeActiveNotification();
        
        if (callTypeRef.current === 'incoming') {
          console.log("Guardando llamada entrante:", callerIdRef.current);
          saveCallToHistory(callerIdRef.current, 'incoming');
        } else if (callTypeRef.current === 'outgoing') {
          console.log("Guardando llamada saliente:", outgoingNumberRef.current);
          saveCallToHistory(outgoingNumberRef.current, 'outgoing');
        } else {
          console.warn("Tipo de llamada no definido:", callTypeRef.current);
          // Fallback: si no sabemos el tipo, intentar determinar por el estado
          if (status === 'calling') {
            // Era una llamada saliente
            saveCallToHistory(outgoingNumberRef.current || destination, 'outgoing');
          }
        }
        
        // Detener tonos
        AudioService.stopAllTones();
        // Reiniciar estado del micrófono al contestar
        setIsMuted(false);
      },
      onCallHangup: () => {
        console.log("Llamada finalizada");
        console.log("Tipo de llamada al colgar:", callTypeRef.current); // Debug
        
        // Calcular duración si hubo conexión
        let duration = 0;
        if (callStartTimeRef.current && status === 'connected') {
          duration = Math.floor((Date.now() - callStartTimeRef.current) / 1000);
        }
        
        // Cerrar notificación si existe
        NotificationService.closeActiveNotification();
        
        // Si era una llamada entrante y no se contestó, guardarla como perdida
        if (callTypeRef.current === 'incoming') {
          console.log("onCallHangup:", callTypeRef.current+", "+callerIdRef.current+", "+ rejectRef.current);
          if (rejectRef.current) {
            // Guardar llamada como rechazada
            saveCallToHistory(callerIdRef.current, 'rejected');
          }else{
            saveCallToHistory(callerIdRef.current, 'missed');
            // Mostrar notificación de llamada perdida
            if (notificationsEnabled) {
              NotificationService.showMissedCallNotification(
                callerIdRef.current,
                // Callback para cuando se hace clic en la notificación
                () => {
                  setDestination(callerIdRef.current);
                  handleTabChange('keypad');
                }
              );
            }
          }
        }
        
        setStatus('registered');
        setSession(null);
        callTypeRef.current = null;
        outgoingNumberRef.current = '';
        callStartTimeRef.current = null;
        rejectRef.current= false;
        // Detener tonos
        AudioService.stopAllTones();
        // Reproducir tono de fin
        AudioService.playEndTone();
        // Reiniciar estados
        setIsMuted(false);
        setIsSpeaker(false);
      },
      onRegistered: () => {
        console.log("Registrado exitosamente en el servidor SIP");
        setStatus('registered');
      },
      onServerConnect: () => {
        console.log("Conectado al servidor WebSocket");
      },
      onServerDisconnect: () => {
        console.log("Desconectado del servidor WebSocket");
        setStatus('disconnected');
      }
    };
    
    console.log("Iniciando conexión SIP...");
    
    // Iniciar y registrar
    ua.connect()
      .then(() => {
        console.log("Conexión establecida, intentando registro");
        return ua.register();
      })
      .then(() => {
        console.log("Registro completo");
        setStatus('registered');
      })
      .catch(error => {
        console.error('Error al conectar:', error);
        setError(`Error de conexión: ${error.message || 'Desconocido'}`);
      });
    
    // Cleanup al desmontar
    return () => {
      if (ua) {
        console.log("Desconectando UA en cleanup");
        if (session) {
          ua.hangup();
        }
        ua.unregister();
        ua.disconnect();
      }
    };
  }, [sesionPreviaActiva]);

  // Funciones para manejar llamadas
  const handleCall = async (numero) => {
    const numeroTemp= numero? numero: destination;
    if (!numeroTemp) {
      setError("Ingresa un número para llamar");
      return;
    }
    
    if (userAgent && status === 'registered') {
      try {
        setError("");
        console.log(`Llamando a ${numeroTemp}...`);
        setStatus('calling');
        callTypeRef.current = 'outgoing';
        outgoingNumberRef.current = numeroTemp;        
        callStartTimeRef.current = Date.now(); // Guardar tiempo de inicio
        console.log("Estableciendo tipo de llamada saliente");
        console.log("callTypeRef.current:", callTypeRef.current);
        console.log("outgoingNumberRef.current:", outgoingNumberRef.current);
        // Guardamos el número para remarcado
        setLastNumber(numeroTemp);
        localStorage.setItem('lastDialedNumber', numeroTemp);

        // Reproducir tono de marcado
        AudioService.startDialTone();
        
        // Reiniciar estado del micrófono
        setIsMuted(false);
        setIsSpeaker(false);
        
        // Opciones de llamada con headers personalizados
        const callOptions = {
          requestDelegate: {
            onAccept: (response) => {
              console.log("Llamada aceptada", response);
              AudioService.stopAllTones();
            },
            onReject: (response) => {
              console.log("Llamada rechazada", response);
              setStatus('registered');
              AudioService.stopAllTones();
              AudioService.playEndTone();
              callTypeRef.current = null;
              outgoingNumberRef.current = '';
              callStartTimeRef.current = null;
            }
          },
          extraHeaders: [
            `GroupID: ${configuracion.grupo}`,
            `GroupName: ${"Grupo"}`,
            `AgentID: ${configuracion.idPbx}`,
          ]
        };
        
        const newSession = await userAgent.call(`sip:${(numeroTemp.length === 10?'52':'')+""+numeroTemp}@${url}`, callOptions);
        setSession(newSession);
      } catch (error) {
        console.error('Error al realizar llamada:', error);
        setError(`Error al realizar llamada: ${error.message || 'Desconocido'}`);
        setStatus('registered');
        AudioService.stopAllTones();
        AudioService.playEndTone();
        callTypeRef.current = null;
        outgoingNumberRef.current = '';
        callStartTimeRef.current = null;
      }
    } else {
      setError("No estás registrado en el servidor SIP");
    }
  };

  // Mantener ref actualizada para BroadcastChannel
  handleCallRef.current = handleCall;

  // Función para remarcar
  const handleRedial = async () => {
    if (!lastNumber) {
      setError("No hay número para remarcar");
      return;
    }
    
    setDestination(lastNumber);
    
    if (userAgent && status === 'registered') {
      try {
        setError("");
        console.log(`Remarcando a ${lastNumber}...`);
        setStatus('calling');
        callTypeRef.current = 'outgoing';
        outgoingNumberRef.current = lastNumber;
        callStartTimeRef.current = Date.now(); // Guardar tiempo de inicio
        // Reproducir tono de marcado
        AudioService.startDialTone();
        
        // Reiniciar estado del micrófono
        setIsMuted(false);
        setIsSpeaker(false);
        
        const callOptions = {
          requestDelegate: {
            onAccept: (response) => {
              console.log("Llamada aceptada", response);
              AudioService.stopAllTones();
            },
            onReject: (response) => {
              console.log("Llamada rechazada", response);
              setStatus('registered');
              AudioService.stopAllTones();
              AudioService.playEndTone();
              callTypeRef.current = null;
              outgoingNumberRef.current = '';
              callStartTimeRef.current = null;
            }
          },
          extraHeaders: [
            `GroupID: ${configuracion.grupo}`,
            `GroupName: ${"Grupo"}`,
            `AgentID: ${configuracion.idPbx}`,
          ]
        };
        
        const newSession = await userAgent.call(`sip:${(lastNumber.length === 10?'52':'')+""+lastNumber}@${url}`, callOptions);
        setSession(newSession);
      } catch (error) {
        console.error('Error al remarcar:', error);
        setError(`Error al remarcar: ${error.message || 'Desconocido'}`);
        setStatus('registered');
        AudioService.stopAllTones();
        AudioService.playEndTone();
        callTypeRef.current = null;
        outgoingNumberRef.current = '';
        callStartTimeRef.current = null;
      }
    } else {
      setError("No estás registrado en el servidor SIP");
    }
  };

  // Función para silenciar/activar micrófono
  const handleToggleMute = () => {
    if (!userAgent || status !== 'connected') {
      return;
    }

    try {
      // Silenciar o activar el micrófono según el estado actual
      if (isMuted) {
        userAgent.unmute();
        console.log("Micrófono activado");
      } else {
        userAgent.mute();
        console.log("Micrófono silenciado");
      }
      
      // Actualizar el estado
      setIsMuted(!isMuted);
    } catch (error) {
      console.error('Error al cambiar estado del micrófono:', error);
      setError(`Error al cambiar micrófono: ${error.message}`);
    }
  };

  // Función para activar/desactivar altavoz
  const handleToggleSpeaker = () => {
    // Esta función es simulada ya que SIP.js no tiene una API directa para el altavoz
    // En una implementación real, aquí se cambiaría el dispositivo de salida de audio
    setIsSpeaker(!isSpeaker);
    console.log(isSpeaker ? "Altavoz desactivado" : "Altavoz activado");
  };

  const handleHangup = () => {
    if (userAgent && (status === 'connected' || status === 'calling')) {
      // Si el micrófono estaba silenciado, lo activamos al colgar
      if (isMuted) {
        userAgent.unmute();
        setIsMuted(false);
      }
      
      // Detener tonos
      AudioService.stopAllTones();
      
      // Cerrar notificación si existe
      NotificationService.closeActiveNotification();
      
      userAgent.hangup();
      setStatus('registered');
      rejectRef.current= true;
    } else if (userAgent && callTypeRef.current === 'incoming') {
      // Rechazar llamada entrante - AQUÍ ES DONDE SE REGISTRA COMO RECHAZADA
      console.log("Rechazando llamada entrante de:", callerIdRef.current);

      userAgent.decline();
      
      // Cerrar notificación si existe
      NotificationService.closeActiveNotification();
      
      // Detener tonos
      AudioService.stopAllTones();
      
      setStatus('registered');
      
      // Limpiar referencias
      //callTypeRef.current = null;
      //callStartTimeRef.current = null;
    }
  };

  const handleAnswer = () => {
    if (userAgent && status === 'ringing') {
      // Detener tono de timbre
      AudioService.stopRingTone();
      
      // Cerrar notificación si existe
      NotificationService.closeActiveNotification();
      
      userAgent.answer();
      setStatus('connected');
      // Aseguramos que el micrófono esté activo al contestar
      setIsMuted(false);
      setIsSpeaker(false);
    }
  };

  // Enviar DTMF durante la llamada
  const sendDTMF = (digit) => {
    if (userAgent && status === 'connected') {
      try {
        userAgent.sendDTMF(digit);
        console.log(`DTMF enviado: ${digit}`);
        
        // Reproducir tono DTMF
        AudioService.playDTMF(digit);
      } catch (error) {
        console.error('Error al enviar DTMF:', error);
      }
    }
  };

  // Añadir dígitos al campo de destino
  const handleDigitPress = (digit) => {
    setDestination(prev => prev + digit);
    AudioService.playDTMF(digit);
  };

  // Borrar el último dígito
  const handleBackspace = () => {
    setDestination(prev => prev.slice(0, -1));
    AudioService.playDTMF('*', 0.05); // Sonido de borrado corto
  };

  // Limpiar el campo
  const handleClear = () => {
    setDestination('');
    AudioService.playDTMF('#', 0.05); // Sonido de limpieza corto
  };

  // Cambiar de pestaña
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Formatear fecha/hora para mostrar en el historial
  const formatCallTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    
    // Determinar si es hoy, ayer o mostrar fecha completa
    if (date.toDateString() === now.toDateString()) {
      // Es hoy, mostrar solo la hora
      return `Hoy, ${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else if (date.toDateString() === yesterday.toDateString()) {
      // Es ayer
      return `Ayer, ${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else {
      // Otro día
      return `${date.getDate()}/${date.getMonth() + 1}, ${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  };
  
  // Obtener icono según tipo de llamada - ACTUALIZADO CON LLAMADAS RECHAZADAS
  const getCallTypeIcon = (type) => {
    switch (type) {
      case 'outgoing':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="call-icon outgoing">
            <path d="m5 19 9-9"></path>
            <path d="m5 10h9v9"></path>
          </svg>
        );
      case 'incoming':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="call-icon incoming">
            <path d="m19 5-9 9"></path>
            <path d="m19 14h-9V5"></path>
          </svg>
        );
      case 'missed':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="call-icon missed">
            <path d="m5 19 9-9"></path>
            <path d="m5 10h9v9"></path>
            <line x1="19" y1="5" x2="5" y2="19"></line>
          </svg>
        );
      case 'rejected':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="call-icon rejected">
            <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path>
            <line x1="23" y1="1" x2="1" y2="23"></line>
          </svg>
        );
      default:
        return null;
    }
  };

  // Renderizado de estado fácil de leer
  const getStatusDisplay = () => {
    switch (status) {
      case 'disconnected': return 'Desconectado';
      case 'connecting': return 'Conectando...';
      case 'registered': return isPaused ? 'En pausa' : 'Listo';
      case 'calling': return 'Llamando...';
      case 'ringing': return 'Timbrando';
      case 'connected': return isMuted ? 'Silenciado' : 'En llamada';
      default: return status;
    }
  };

  return (
    <div 
      className="telefonosip-container" 
      ref={phoneContainerRef}
      tabIndex="0" // Hace que el div pueda recibir foco
    >{console.log("user",usuario)}
      <div className="telefonosip-wrapper">
        {/* iPhone frame y Dynamic Island */}
        <div className="iphone">
          <div className="iphone-frame">
            <div className="dynamic-island">
              <div className="dynamic-island-camera-left"></div>
              <div className="dynamic-island-camera-right"></div>
            </div>
          </div>

          {/* Status Bar */}
          <div className="status-bar">
            <span className="time">{currentTime + "  v3"}</span>
            <div className="signal-icons">
              <div className="signal-dot"></div>
              <div className="signal-dot"></div>
              <div className="signal-dot"></div>
              <div className="signal-dot"></div>
              <div className="battery"></div>
            </div>
          </div>

          {/* Phone Interface */}
          <div className="phone-interface">
            {/* Estado SIP (discreto en la parte superior) */}
            {(status !== 'registered' || isPaused) && (
              <div style={{ 
                padding: '8px 16px',
                textAlign: 'center',
                fontSize: '14px',
                backgroundColor: status === 'connecting' ? '#fff8e1' : 
                              status === 'disconnected' ? '#ffebee' : 
                              status === 'ringing' ? '#e8f5e9' : 
                              isPaused ? '#fff3e0' : '#fff8e1',
                color: '#333'
              }}>
                {getStatusDisplay()}
                {// 0 inicialización sin validar, 1 validando, 2 sesion previa activa, 3 sesion previa inactiva
                  sesionPreviaActiva === 0? " iniciando" :
                    sesionPreviaActiva === 1? " validando si hay sesiones previas" :
                    sesionPreviaActiva === 2? " sesion previa activa, por favor cierre sesiones previas en otros equipos" :
                    sesionPreviaActiva === 0? "" : ""
                }
              </div>
            )}

            {/* Mensaje de error */}
            {error && (
              <div style={{ 
                padding: '8px 16px',
                textAlign: 'center', 
                color: '#ef4444',
                fontSize: '14px',
                backgroundColor: 'rgba(239, 68, 68, 0.1)'
              }}>
                {error}
              </div>
            )}

            {/* Tabs de navegación (abajo) */}
            <div className="tabs-container">
              <div className="tabs">
                <button 
                  className={`tab-button ${activeTab === 'favorites' ? 'active' : ''}`}
                  onClick={() => handleTabChange('favorites')}
                >
                  Favoritos
                </button>
                <button 
                  className={`tab-button ${activeTab === 'recents' ? 'active' : ''}`}
                  onClick={() => handleTabChange('recents')}
                >
                  Recientes
                  {(callHistory.some(call => call.type === 'missed') || callHistory.some(call => call.type === 'rejected')) && (
                    <span className="missed-call-badge"></span>
                  )}
                </button>
                <button 
                  className={`tab-button ${activeTab === 'keypad' ? 'active' : ''}`}
                  onClick={() => handleTabChange('keypad')}
                >
                  Teclado
                </button>
              </div>
            </div>

            {/* Contenido de las pestañas */}
            <div className="tab-content">
              {/* Keypad Tab */}
              <div className={`tab-pane ${activeTab === 'keypad' ? 'active' : ''}`}>
                <div className="keypad-container">
                  <div className="phone-number-display">
                    <h2 id="phone-number-text">{destination || ""}</h2>
                    <div className="keyboard-help">
                      {status === 'registered' && (
                        <div className="keyboard-tip">
                          Usa el teclado numérico para marcar • Enter para llamar • P para {isPaused ? 'reanudar' : 'pausar'}
                        </div>
                      )}
                      {status === 'connected' && (
                        <div className="keyboard-tip">M: silenciar • S: altavoz • Esc: colgar</div>
                      )}
                    </div>
                  </div>

                  <div className="dial-pad">
                    <div className="dial-pad-row">
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('1')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">1</span>
                        <span className="letters"></span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('2')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">2</span>
                        <span className="letters">ABC</span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('3')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">3</span>
                        <span className="letters">DEF</span>
                      </button>
                    </div>
                    <div className="dial-pad-row">
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('4')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">4</span>
                        <span className="letters">GHI</span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('5')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">5</span>
                        <span className="letters">JKL</span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('6')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">6</span>
                        <span className="letters">MNO</span>
                      </button>
                    </div>
                    <div className="dial-pad-row">
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('7')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">7</span>
                        <span className="letters">PQRS</span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('8')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">8</span>
                        <span className="letters">TUV</span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('9')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">9</span>
                        <span className="letters">WXYZ</span>
                      </button>
                    </div>
                    <div className="dial-pad-row">
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('*')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">*</span>
                        <span className="letters"></span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('0')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">0</span>
                        <span className="letters">+</span>
                      </button>
                      <button 
                        className="dial-button" 
                        onClick={() => handleDigitPress('#')}
                        disabled={status === 'calling' || status === 'ringing'}
                      >
                        <span className="digit">#</span>
                        <span className="letters"></span>
                      </button>
                    </div>
                    
                    {/* Controles inferiores */}
                    <div className="dial-pad-controls">
                      {/* Botón de pausa (izquierda) */}
                      <button 
                        className={`control-icon-button pause-button ${isPaused ? 'active' : ''} ${isProcessingPause ? 'processing' : ''}`}
                        onClick={handleTogglePause}
                        disabled={status !== 'registered' || isProcessingPause}
                        title={isPaused ? 'Reanudar llamadas entrantes (P)' : 'Pausar llamadas entrantes (P)'}
                      >
                        {isProcessingPause ? (
                          // Icono de carga/procesando
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="spin">
                            <line x1="12" y1="2" x2="12" y2="6"></line>
                            <line x1="12" y1="18" x2="12" y2="22"></line>
                            <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                            <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                            <line x1="2" y1="12" x2="6" y2="12"></line>
                            <line x1="18" y1="12" x2="22" y2="12"></line>
                            <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                            <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                          </svg>
                        ) : isPaused ? (
                          // Icono de play (reanudar)
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="5 3 19 12 5 21 5 3"></polygon>
                          </svg>
                        ) : (
                          // Icono de pausa
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="6" y="4" width="4" height="16"></rect>
                            <rect x="14" y="4" width="4" height="16"></rect>
                          </svg>
                        )}
                      </button>
                      
                      {/* Botón de llamada (centro) */}
                      {status === 'registered' ? (
                        <button 
                          className={`call-button-large ${!destination ? 'disabled' : ''}`}
                          onClick={()=> handleCall()}
                          disabled={!destination}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                          </svg>
                        </button>
                      ) : status === 'calling' || status === 'connected' ? (
                        <button 
                          className="end-call-button-large"
                          onClick={handleHangup}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path>
                            <line x1="23" y1="1" x2="1" y2="23"></line>
                          </svg>
                        </button>
                      ) : status === 'ringing' ? (
                        <button 
                          className="call-button-large"
                          onClick={handleAnswer}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                          </svg>
                        </button>
                      ) : null}
                      
                      {/* Botón de borrar (derecha) */}
                      {status !== 'connected' && status !== 'calling' && status !== 'ringing' && (
                        <button 
                          className="control-icon-button backspace-button-redesigned" 
                          onClick={handleBackspace}
                          disabled={!destination}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 19l-7-7 7-7"></path>
                            <path d="M19 12H5"></path>
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>

                  
                  {/* Botón de remarcado */}
                  {lastNumber && status === 'registered' && (
                    <div className="redial-button-container">
                      <button 
                        onClick={handleRedial}
                        className="redial-button"
                      >
                        Remarcar: {lastNumber}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Recents Tab */}
              <div className={`tab-pane ${activeTab === 'recents' ? 'active' : ''}`}>
                <div className="recents-container">
                  <div className="recents-header">
                    <h2 className="section-title">Recientes</h2>
                    {callHistory.length > 0 && (
                      <button className="clear-history-button" onClick={clearCallHistory}>
                        Borrar
                      </button>
                    )}
                  </div>
                  
                  <div className="recents-list">
                    {isLoadingHistory ? (
                      <div className="loading-indicator">Cargando historial...</div>
                    ) : callHistory.length === 0 ? (
                      <div className="empty-history">
                        <div className="empty-icon">📞</div>
                        <p>No hay llamadas recientes</p>
                      </div>
                    ) : (
                      callHistory.map(call => (
                        <div 
                          key={call.id} 
                          className={`recent-call ${call.type}`}
                          onClick={() => {
                            setDestination(call.number);
                            handleTabChange('keypad');
                          }}
                        >
                          <div className="avatar">
                            <div className="avatar-text">{getInitial(call.number)}</div>
                            {(call.type === 'missed' || call.type === 'rejected') && <div className="missed-indicator"></div>}
                          </div>
                          <div className="call-info">
                            <p className="name">{call.number}</p>
                            <div className="time">
                              {getCallTypeIcon(call.type)}
                              <span>{formatCallTime(call.timestamp)}</span>
                            </div>
                          </div>
                          <button 
                            className="call-icon-button" 
                            onClick={(e) => {
                              e.stopPropagation();
                              setDestination(call.number);
                              handleCall();
                            }}
                            disabled={status !== 'registered'}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>

              {/* Favorites Tab */}
              <div className={`tab-pane ${activeTab === 'favorites' ? 'active' : ''}`}>
                <div className="favorites-container">
                  <div className="favorites-header">
                    <h2 className="section-title">Favoritos</h2>
                    <button className="edit-button">Editar</button>
                  </div>
                  <div className="favorites-grid">
                    {lastNumber && (
                      <div className="favorite-contact">
                        <div className="avatar large">
                          <div className="avatar-text">{lastNumber.charAt(0)}</div>
                        </div>
                        <p className="name">{lastNumber}</p>
                        <div className="contact-actions">
                          <button className="action-button call" onClick={() => {
                            setDestination(lastNumber);
                            handleTabChange('keypad');
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    )}
                    {!lastNumber && (
                      <div style={{ 
                        gridColumn: 'span 2', 
                        textAlign: 'center', 
                        color: '#777', 
                        padding: '20px' 
                      }}>
                        No hay contactos favoritos
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pantalla de llamada (se muestra cuando hay una llamada activa o en progreso) */}
          {(status === 'connected' || status === 'calling') && (
            <div className="call-screen">
              <div className="call-header">
                <button className="icon-button" onClick={handleHangup}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
              </div>

              <div className="caller-info">
                <div className="avatar extra-large">
                  <div className="avatar-text">{getInitial(destination)}</div>
                </div>
                <h2 className="caller-number">{destination}</h2>
                <p className="call-status">
                  {status === 'connected' ? 'Conectado' : 'Llamando...'}
                </p>
              </div>

              <div className="call-animation">
                {status === 'connected' && (
                  <>
                    <div className="animation-circle connected-circle" style={{ width: '120px', height: '120px' }}></div>
                    <div className="sound-wave" style={{ width: '160px', height: '160px' }}></div>
                    <div className="sound-wave" style={{ width: '200px', height: '200px', animationDelay: '0.2s' }}></div>
                  </>
                )}
                {status === 'calling' && (
                  <>
                    <div className="animation-circle calling-circle" style={{ width: '120px', height: '120px' }}></div>
                    <div className="ripple" style={{ animationDelay: '0s' }}></div>
                    <div className="ripple" style={{ animationDelay: '0.6s' }}></div>
                    <div className="ripple" style={{ animationDelay: '1.2s' }}></div>
                  </>
                )}
              </div>

              <div className="call-controls">
                <div className="control-buttons">
                  <button 
                    className={`control-button ${isMuted ? 'active' : ''}`}
                    onClick={handleToggleMute}
                  >
                    <div className="button-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                        <line x1="12" y1="19" x2="12" y2="23"></line>
                        <line x1="8" y1="23" x2="16" y2="23"></line>
                      </svg>
                    </div>
                    <span>silenciar</span>
                  </button>
                  <button 
                    className="control-button"
                    onClick={() => sendDTMF('0')}
                  >
                    <div className="button-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10 2h4"></path>
                        <path d="M12 14v-4"></path>
                        <path d="M4 13a8 8 0 0 1 8-7 8 8 0 0 1 8 7v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"></path>
                      </svg>
                    </div>
                    <span>teclado</span>
                  </button>
                  <button 
                    className={`control-button ${isSpeaker ? 'active' : ''}`}
                    onClick={handleToggleSpeaker}
                  >
                    <div className="button-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
                      </svg>
                    </div>
                    <span>altavoz</span>
                  </button>
                </div>

                <div className="end-call-container">
                  <button 
                    className="end-call-button"
                    onClick={handleHangup}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path>
                      <line x1="23" y1="1" x2="1" y2="23"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Pantalla de llamada entrante */}
          {status === 'ringing' && (
            <div className="call-screen">
              <div className="caller-info" style={{ paddingTop: '60px' }}>
                <div className="avatar extra-large">
                  <div className="avatar-text">{numeroEntrante && numeroEntrante.length ? getInitial(numeroEntrante): ""}</div>
                </div>
                <h2 className="caller-number">{numeroEntrante}</h2>
                <p className="call-status">Llamada entrante</p>
              </div>

              <div className="call-animation">
                <div className="animation-circle calling-circle" style={{ width: '120px', height: '120px' }}></div>
                <div className="ripple" style={{ animationDelay: '0s' }}></div>
                <div className="ripple" style={{ animationDelay: '0.6s' }}></div>
                <div className="ripple" style={{ animationDelay: '1.2s' }}></div>
              </div>

              <div className="call-controls" style={{ bottom: '40px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '40px' }}>
                  <button 
                    className="end-call-button"
                    onClick={handleHangup}
                    style={{ transform: 'rotate(135deg)' }}
                    title="Rechazar llamada"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path>
                      <line x1="23" y1="1" x2="1" y2="23"></line>
                    </svg>
                  </button>
                  
                  <button 
                    className="call-button-large"
                    onClick={handleAnswer}
                    title="Contestar llamada"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Solo necesitamos mantener los elementos de audio para SIP.js */}
          <audio ref={remoteAudioRef} autoPlay style={{ display: 'none' }} />
          <audio ref={localAudioRef} muted style={{ display: 'none' }} />
        </div>
      </div>
    </div>
  );
}

export default TelefonoSipV3;